// @ts-check

/**
 * Module-level customer type — updated by AuthContext on every auth state change.
 * Using a module variable avoids relying on a localStorage key that is never set
 * by the existing auth flow.
 *
 * @type {'retail'|'educator'|'school'|'guest'}
 */
let _customerType = 'guest';

/**
 * Call this from AuthContext whenever the user changes (login, logout, profile load).
 * @param {'retail'|'educator'|'school'|'guest'|null|undefined} type
 */
export const setCustomerType = (type) => {
  _customerType = type || 'guest';
};

/**
 * Fire an analytics event. Auto-appends Tier 1 properties (customer_type, currency)
 * to every event so individual call sites don't need to repeat them.
 *
 * Events are dispatched as a DOM CustomEvent ('nls:analytics') so:
 * - Multiple analytics providers can listen without coupling to this module.
 * - No real provider is required in development — open DevTools Events panel to verify.
 *
 * @param {string} eventName
 * @param {Record<string, unknown>} [props]
 */
export const track = (eventName, props = {}) => {
  const tier1 = {
    customer_type: _customerType,
    currency: localStorage.getItem('nls_currency') || 'USD',
  };
  window.dispatchEvent(
    new CustomEvent('nls:analytics', {
      detail: { event: eventName, ...tier1, ...props },
    })
  );
};
